import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex items-center bg-slate-100 p-1 rounded-xl border border-slate-200">
      <button onClick={() => setLang('en')} className={`px-3 py-1.5 rounded-lg text-xs font-black transition-all ${lang === 'en' ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-400 hover:text-slate-600'}`}>
        EN
      </button>
      <button onClick={() => setLang('ar')} className={`px-3 py-1.5 rounded-lg text-xs font-black transition-all ${lang === 'ar' ? 'bg-white text-green-600 shadow-sm' : 'text-slate-400 hover:text-slate-600'}`}>
        عربي
      </button>
    </div>
  );
};

export default LanguageSwitcher;